import { Option as SelectOption } from '@node-space/storybook-components/dist/Select'
import SelectGroup from '@node-space/storybook-components/dist/SelectGroup'

export const isValidPercentage = (value: string): boolean => {
  const percentage = Number(value)
  if (isNaN(percentage)) return false
  if (percentage < 0 || percentage > 100) return false
  return true
}

export const getSelectGroupFilterOptions = (
  option: SelectOption,
  inputValue: string,
  options: SelectGroup[]
) => {
  const searchQuery = inputValue?.toLowerCase()
  if (option?.label?.toLowerCase()?.includes(searchQuery)) return true
  const matchedGroups = options?.filter(groupOption =>
    groupOption?.label?.toLowerCase()?.includes(searchQuery)
  )
  if (matchedGroups) {
    for (const group of matchedGroups) {
      const matchedGroupOption = group?.options?.find(
        groupOption => groupOption?.value === option?.value
      )
      if (matchedGroupOption) {
        return true
      }
    }
  }
  return false
}
